import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import classnames from 'classnames';

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['strong', 'br', 'em', 'a', 'span'],
  allowedAttributes: { span: ['style'] }
};

type Props = {
  title?: string | null,
  subtitle?: string | null,
  align?: 'center'
};

class ModalFrameHeader extends React.PureComponent<Props> {
  static defaultProps = {
    align: 'center'
  };

  render() {
    const { align, title, subtitle } = this.props;

    const classes = classnames({
      'modal-frame-header': true,
      [`modal-frame-header--align-${String(align)}`]: align
    });

    return (
      <div className={classes}>
        {
          title &&
            <div
              className="modal-frame-header__title"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(title, SANITIZE_HTML_CONFIG) }}
            />
        }
        {
          subtitle &&
            <div
              className="modal-frame-header__subtitle"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(subtitle, SANITIZE_HTML_CONFIG) }}
            />
        }
      </div>
    );
  }
}

export default ModalFrameHeader;
